module.exports = __webpack_public_path__ + "img/vvpXOM8aw06T4ntRjKMhtaLRgp4.fd67cf4b.jpg";